const MODULE_CODE = 'member_register'

export default {
  methods: {
    async goNext(next) {
      switch (next) {
        case "registered_page":
          await this.goSuccess();
          return false;
        case "success_page":
          await this.$router.push({
            name: "LiffRegisterWelcome",
            params: {
              orgCode: this.$route.params.orgCode,
            },
          });
          return false;
        case "form_page":
          // 如果當前頁面不在這個範圍內，則前往
          if (! ['LiffRegisterMember', 'LiffRegisterTerms'].includes(this.$route.name)) {
            await this.$router.push({
              name: "LiffRegisterMember",
              params: {
                orgCode: this.$route.params.orgCode,
              },
              query: this.$route.query,
            });
            return false;
          }
          break;
        case "verify_page":
          // 如果當前頁面不在這個範圍內，則前往
          if (! ['LiffRegisterValidate'].includes(this.$route.name)) {
            await this.$router.push({
              name: "LiffRegisterValidate",
              params: {
                orgCode: this.$route.params.orgCode,
              },
            });
            return false;
          }
          break;
        case "verify_form_page":
          if (! ['LiffRegisterTerms', 'LiffRegisterValidate', 'LiffRegisterVerifyForm'].includes(this.$route.name)) {
            await this.$router.push({
              name: "LiffRegisterVerifyForm",
              params: {
                orgCode: this.$route.params.orgCode,
              },
              query: this.$route.query,
            });
            return false;
          }
          break;
        case "external_register":
          await this.$router.push({
            name: "LiffRegisterNotRegister",
          });
          return false;
        case "check_overwrite_binding":
          await this.$router.push({
            name: "LiffRegisterOverwriteCheck",
          });
          return false;
        case "field_missed":
          await this.$router.push({
            name: "LiffRegisterInfo",
            params: {
              type: "field_missed"
            }
          });
          return false;
        case "provider_error":
          await this.$router.push({
            name: "LiffRegisterProviderError",
          });
          return false;
        case "binding_error":
          this.$router.push({
            name: "LiffRegisterBindingError",
          });
          return false;
        case "bypass_remind_page":
          await this.$router.push({
            name: "LiffRegisterBypassRemind",
          });
          return false;
        default:
          return true;
      }
    },
    getModuleConfig(key) {
      return this.$store.getters["liffModule/getConfig"](MODULE_CODE, key);
    },
    async goSuccess() {
      // 如果有指定 redirect URI（例如來自同心預約系統），直接導向
      if (this.$store.getters['route/hasIntended']) {
        await this.$store.dispatch('route/intended')
        return
      }

      var registeredAction = this.getModuleConfig('registered_action')

      switch (registeredAction) {
        // member-center 前往會員中心
        case "member-center":
          await this.$router.push({ name: "LiffMemberCenterHome" });
          break;
        case "member-edit":
          await this.$router.push({ name: "LiffMemberCenterEdit" });
          break;
        case "edit_done":
          await this.$router.push({ name: "LiffMemberCenterEditDone" });
          break;
        case "thanks":
          await this.$router.push({ name: "LiffRegisterThanks" });
          break;
        case "intro":
          await this.$router.push({ name: "LiffRegisterIntro" });
          break;
        case "register":
          await this.$router.push({ name: "LiffRegisterIndex" });
          break;
        case "welcome":
        default:
          await this.$router.push({
            name: "LiffRegisterWelcome",
            params: {
              orgCode: this.$route.params.orgCode,
            },
          });
          break;
      }
    },
    trans(key, defaultMessage, params) {
      let trans = this.getModuleConfig(`trans.${key}`) || defaultMessage;

      if (params) {
        trans = trans.replace(/\{(\w+)\}/g, (_, key) => params[key] || '');
      }

      return trans
    },
  }
}
